<template>
  <div id="thumbnails">
    <div class="main">
      <div
        v-if="start > 7"
        class="prevPage navigate"
        @click="changePage('back')"
      >
        <div class="trigger">
          <i
            class="icon-m-back"
            aria-hidden="true"
          />
        </div>
        <span class="desc">上一頁</span>
      </div>
      <div class="panel">
        <div
          v-for="(service, index) in serviceCardArray.slice(start, end)"
          :key="index"
          class="thumbnail"
          @click="clickServiceCard(service)"
        >
          <div
            v-if="service.badge"
            class="badge"
          >
            {{ service.badge }}
          </div>
          <i
            :class="service.iconName"
            aria-hidden="true"
          />
          <div class="caption">
            {{ $t(`CommunityMainService.${service.i18nKey}`) }}
          </div>
        </div>
      </div>
      <div
        v-if="serviceCardArray.length - end > 0"
        class="nextPage navigate"
        @click="changePage('add')"
      >
        <div class="trigger">
          <i
            class="icon-m-next"
            aria-hidden="true"
          />
        </div>
        <span class="desc">下一頁</span>
      </div>
    </div>
    <dialog-visitor
      ref="dialogVisitor"
      @updateHeaderCount="updateHeaderframeCount"
    />
    <fast-active
      ref="FastActive"
      @updateHeaderCount="updateHeaderframeCount"
    />
  </div>
</template>

<script>
import dialogVisitor from '@/components/DialogVisitor'
import FastActive from '@/components/FastActive'
import { CommunityMainServiceType } from '@/js/utils/communityMainService'


export default {
  components: {
    'dialog-visitor': dialogVisitor,
    'fast-active': FastActive
  },
  data () {
    return {
      tab: 1,
      // 更新 ICON 教學看這邊
      // https://kingnetrd.visualstudio.com/RD-ProjectWorkItem/_wiki/wikis/RD-ProjectWorkItem.wiki/901/icomoon-%E4%BD%BF%E7%94%A8%E6%96%B9%E5%BC%8F
      start: 0,
      end: 8,
      loading: null
    }
  },
  computed: {
    serviceCardArray () {
      // 直接拿 Navbar 獲取到的資料來用
      let _serviceCardArray = this.$store.state.localStorage.communityMainService || []
      // 有 icon 才會顯示
      _serviceCardArray = _serviceCardArray.filter((service) => service.iconName)
      // 回到上次停留的頁數或第一頁
      this.toPreviousOrFirstServiceCardPage(_serviceCardArray)
      return _serviceCardArray
    }
  },
  mounted () {
    vuecp.thumbnails = this
  },
  methods: {
    clickServiceCard (service) {
      this.$sendGAEvent('功能卡片使用數', {
        value: `click_${service.rawZhName}`
      })
      const navigate = () => {
        switch (service.project) {
        case 'mgmt':
          this.$router.push(service.url)
          break
        case 'housekeeper':
          window.location.href = `${window.location.origin}/community/${service.url}`
          break
        case 'serverless':
          // 目前只有正式環境，無測試環境
          window.location.href = `https://www.kingnetsmart.com.tw/serverless/${service.url}`
          break
        default:
          break
        }
      }
      const clickPlugin = () => {
        switch (service.Id) {
        case -1:
          // 訪客離開
          this.$refs.dialogVisitor.fastLeave()
          break
        default:
          navigate()
          break
        }
      }
      const clickFixed = () => {
        switch (service.Id) {
        case 1:
          // 住戶開通
          this.$refs.FastActive.faseActive()
          break
        default:
          navigate()
          break
        }
      }
      switch (service.CommunityMainServiceType) {
      case CommunityMainServiceType.Plugin:
        // 一般功能
        clickPlugin()
        break
      case CommunityMainServiceType.Fixed:
        // 常開功能
        clickFixed()
        break
      default:
        break
      }
    },
    changePage (mode) {
      // eslint-disable-next-line eqeqeq
      if (mode == 'add') {
        this.start += 8
        this.end += 8
      } else {
        if (this.start >= 8 && this.end >= 16) {
          this.start -= 8
          this.end -= 8
        }
      }
      // 記錄當前停留的頁數
      sessionStorage.setItem('serviceCardIndex', this.start)
    },
    updateHeaderframeCount () {
      document.body.style.overflow = null
      if (this.$refs.headerframe) {
        this.$refs.headerframe.getNavbarBadgeCount()
      }
    },
    toPreviousOrFirstServiceCardPage (serviceCardArray) {
      // 回到上次停留的頁數或第一頁
      const serviceCardIndex = JSON.parse(sessionStorage.getItem('serviceCardIndex')) || 0
      if (serviceCardIndex <= serviceCardArray.length - 1) {
        // 依卡片數確認，若目標頁存在、回到先前所停留的頁數
        this.start = serviceCardIndex
      } else {
        // 否則回到第一頁
        this.start = 0
        sessionStorage.setItem('serviceCardIndex', 0)
      }
      this.end = this.start + 8
    }
  }
}
</script>

<style lang="sass" scoped>
#thumbnails
  margin-top: 60px
  .main
    position: relative
    width: 990px
    height: 473px
    margin-left: -15px
  .panel
    display: flex
    justify-content: flex-start
    flex-wrap: wrap
    margin-top: 30px
    .thumbnail
      position: relative
      flex: 0 0 215px
      background-color: #fff
      margin: 15px
      text-align: center
      display: flex
      align-items: center
      justify-content: center
      flex-wrap: wrap
      cursor: pointer
      box-shadow: 3px 3px 7px -1px $bgDark1
      border-radius: 8px
      &:hover
        background-color: $whiteHover
      i
        width: 100%
        height: 30%
        margin-top: 45px
        margin-bottom: 10%
        color: $mainColor
        font-size: 60px
      .caption
        font-size: 30px
        color: #4B4B4B
        margin-bottom: 35px
        margin-top: 15px
      .badge
        position: absolute
        top: 12px
        right: 12px
        display: flex
        justify-content: center
        align-items: center
        min-width: 28px
        height: 30px
        padding: 0 9px
        border-radius: 20px
        font-size: map-get($fontSize,large)
        font-weight: 600
        color: #fff
        background: $bgOrange
        border: 1px solid $bgOrange
  .nextPage
    cursor: pointer
    top: 50%
    width: 50px
    margin: auto 0px
    position: absolute
    right: -58px
  .prevPage
    cursor: pointer
    top: 50%
    width: 50px
    margin: auto 0px
    position: absolute
    left: -58px
  .navigate
    margin: auto 0
    transform: translateY(-30%)
    .trigger
      font-size: 60px
      color: #2b2b2b
      opacity: 0.7
      text-align: center
      margin-bottom: 7px
      &:hover
        opacity: 1
    .desc
      color: #5f5f5f
</style>
